import React from "react";
import { useSelector } from "react-redux";
import { Header2, Title2 } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { getIsOnDemand } from "~/store/selectors/selector.configOptions";
import { BackButton } from "./BackButton";

const PageHeader = ({ disableBackBtn, title, backUrl, backTitle, className, children, forceUrl }) => {
  const isOnDemand = useSelector(getIsOnDemand);

  return (
    <div
      className={classNames(
        "tw-flex tw-items-center tw-justify-between tw-my-3 tw-w-full tw-h-10 tw-shrink-0",
        className
      )}
    >
      <div className="tw-flex tw-items-center sm:tw-min-w-0 tw-max-w-full tw-w-full">
        {disableBackBtn || !backUrl || !backTitle ? null : (
          <BackButton
            url={backUrl}
            title={backTitle}
            className="tw-mr-1 md:tw-mr-2"
            forceUrl={forceUrl}
          />
        )}
        {title ? (
          <>
            <Title2 className="tw-hidden md:tw-block tw-mr-2 tw-truncate ">{title}</Title2>
            <Header2
              weight="light"
              className="tw-block md:tw-hidden tw-mr-2 tw-truncate"
            >
              {title}
            </Header2>
          </>
        ) : null}
        <div className="tw-shrink-0">{children}</div>
      </div>
      <div
        className={classNames("tw-h-full tw-shrink-0 tw-hidden sm:tw-flex", {
          "tw-w-52": !isOnDemand,
          "tw-w-60": isOnDemand,
        })}
      />
    </div>
  );
};

PageHeader.displayName = "PageHeader";

PageHeader.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  disableBackBtn: PropTypes.bool,
  backUrl: PropTypes.string,
  title: PropTypes.string,
  backTitle: PropTypes.string,
  forceUrl: PropTypes.bool,
};

export default PageHeader;
